<template>
  <div class="l_alert animation__background">
    <div class="l_alert__panel animation__popup">
      <div class="container">
        <div class="title">
          <p v-if="title.length > 0" v-html="title" />
        </div>
        <div class="description">
          <p v-if="message.length > 0" v-html="message" />
        </div>
        <div class="footer">
          <button v-if="secondaryLabel.length > 0" @click="tapSecondary" class="secondary">{{ secondaryLabel }}</button>
          <div class="divider" v-if="secondaryLabel.length > 0 && primaryLabel.length > 0" />
          <button v-if="primaryLabel.length > 0" @click="tapPrimary" class="primary">{{ primaryLabel }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertPrimarySecondary',
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    primaryLabel: { type: String, default: '' },
    secondaryLabel: { type: String, default: '' }
  },
  methods: {
    tapPrimary() {
      this.$emit('tapPrimary')
    },
    tapSecondary() {
      this.$emit('tapSecondary')
    }
  }
}
</script>

<style scoped lang="scss">
.l_alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.l_alert__panel {
  width: 270px;
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%,
  100%,
  20%,
  50%,
  80% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(0.93, 0.93);
  }
  60% {
    transform: scale(0.98, 0.98);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.l_alert .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: space-around;
  border: 1px solid #eeeeee;
  border-radius: 12px;
  background-color: #ffffff;
  padding-top: 10px;
}

.l_alert .container .title {
  font-family: 'HiraKakuPro-W6';
  font-size: 17px;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #333333;
  padding: 15px 0 0;
}

.l_alert .container .description {
  font-size: 16px;
  text-align: left;
  color: #333333;
  margin-top: 4px;
  margin-right: 12px;
  margin-left: 12px;
}

.l_alert .container .footer {
  padding-top: 25px;
  width: 100%;
  display: flex;
}

.l_alert .container .footer button {
  font-family: 'HiraKakuPro-W3';
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  background-color: #ffffff;
  color: #602209;
  padding: 12px 0px;
  outline: none;
  flex-grow: 1;
  border: none;
  border-top: 1px solid #eeeeee;
  width: 100%;
}

.l_alert .container .footer .divider {
  width: 1px;
  background: #eeeeee;
}

.l_alert .container .footer button.secondary {
  border-radius: 0 0 20px 20px;
}

.l_alert .container .footer button.primary {
  border-radius: 0 0 20px 20px;
}
</style>
